<template>
    <div>
        <div class="row">
            <div class="column small-7">
                <PageTitle title="Producten" :total="total" :loading="loading" />
            </div>
            <div class="column small-5 text-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left" v-if="user.role != 'admin'">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" :to="{ name: 'ProductsRecord', params: {id: 'nieuw'} }" type="is-dark">Nieuw</b-button>
            </div>
        </div>

        <ProductReturnModal
            ref="ProductReturnModal"
            :show="show_return_product_modal"
            @closeProductReturnModal="show_return_product_modal = false"
            @reload="loadAsyncData"
        />

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                {{ organisations[props.row.organisation].short_name }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="name" label="Product" sortable>
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="quantitiy" label="Beschikbaar" width="100" class="show-for-large" sortable>
                            <span v-if="hideSensitiveData">
                                <span v-if="props.row.stock == 0">N.v.t.</span>
                                <span v-else-if="props.row.quantity && props.row.available">**/**</span>
                                <span v-else>-</span>
                            </span>
                            <span v-else-if="props.row.stock == 0">N.v.t.</span>
                            <span v-else-if="props.row.quantity && props.row.available">
                                {{ props.row.available }}/{{ props.row.quantity }}
                            </span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="price" label="Prijs" width="100" sortable numeric>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.price > 0">&euro;&nbsp;{{ props.row.price }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Inleveren" width="100">
                            <b-tooltip :label="props.row.leased_count == 0 ? 'Geen verhuurde producten om in te leveren' : 'Product uit contract inleveren'">
                                <b-button :type="props.row.leased_count == 0 ? 'is-light' : 'is-success'" size="is-small" icon-left="plus" :disabled="props.row.leased_count == 0" @click="showReturnProductModal(props.row)" />
                            </b-tooltip>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Factuur" width="100">
                            <b-tooltip label="Factuur maken met dit product">
                                <b-button tag="router-link" :to="{ name: 'CreateInvoiceRecord', query: {type: 'los', products: props.row.id} }" type="is-primary" size="is-small" icon-left="euro-sign" />
                            </b-tooltip>
                        </b-table-column>

                        <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="180" sortable>
                            <span>{{ props.row.updated_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'ProductsRecord', params: {id: props.row.id} }">Bekijken</b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen producten gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import ProductReturnModal from './ProductReturnModal'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'ProductsOverview',

    components: {
        ProductReturnModal
    },

    mixins: [filtersMixin, paramsMixin],

    data () {
        return {
            records: [],

            total: null,
            loading: false,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: typeof(this.$store.state.searchQueries['ProductsOverview']) != 'undefined' ? this.$store.state.searchQueries['ProductsOverview'] : null,

            show_return_product_modal: false
        }
    },

    computed: {
        paginated(){
            return this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created () {
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'ProductsOverview')

            this.loading = true

            axios.get(`/api/products?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'ProductsOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching products:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })

        },

        showReturnProductModal(product){
            this.$refs['ProductReturnModal'].fetchContractWhereProduct(product)

            this.show_return_product_modal = true
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>